// src/pages/Contacto.js
import { useEffect, useState } from 'react';
import '../styles/contacto.css';

export default function Contacto() {
    const [data, setData] = useState(null);
    const [cargando, setCargando] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        let cancel = false;

        (async () => {
            try {
                const r = await fetch('/data/contacto.json', { cache: 'no-store' });
                if (!r.ok) throw new Error('HTTP ' + r.status);
                const json = await r.json();
                if (cancel) return;
                setData(json);
                if (json?.seoTitle) document.title = json.seoTitle;
            } catch (e) {
                console.error('[Contacto] Error cargando /data/contacto.json:', e);
                if (!cancel) {
                    setError(true);
                    // no seteamos textos por defecto para evitar hardcodear en JSX
                }
            } finally {
                if (!cancel) setCargando(false);
            }
        })();

        return () => { cancel = true; };
    }, []);

    // 1) Cargando: aún no hay JSON → evitamos texto hardcodeado
    if (cargando || !data) {
        return (
            <section className="contacto-hero-rediseño" aria-busy="true" style={{ minHeight: 140 }} />
        );
    }

    // 2) Error: si hay error mostramos mensaje desde el propio JSON (si existe)
    if (error && data?.ui?.loadError) {
        return (
            <section className="contacto-hero-rediseño">
                <h1 className="titulo-contacto">{data.sectionTitle}</h1>
                <hr className="linea-separadora" />
                <p role="alert" className="contacto-hero-subtitulo">{data.ui.loadError}</p>
            </section>
        );
    }

    const phones = Array.isArray(data.info?.phones) ? data.info.phones : [];
    const emails = Array.isArray(data.info?.emails) ? data.info.emails : [];

    return (
        <div>
            {/* HERO */}
            <section className="contacto-hero-rediseño">
                <h1 className="titulo-contacto">{data.sectionTitle}</h1>
                <hr className="linea-separadora" />
                {data.hero?.title && (
                    <p
                        className="contacto-hero-titulo"
                        dangerouslySetInnerHTML={{ __html: data.hero.title }}
                    />
                )}
                {data.hero?.subtitle && (
                    <p className="contacto-hero-subtitulo">{data.hero.subtitle}</p>
                )}
            </section>

            {/* CUERPO: sólo datos de contacto (sin formulario) */}
            <section className="contacto-contenedor-principal">
                <div className="contacto-ayuda-box">
                    {/* Bloque de ayuda */}
                    <div className="contacto-ayuda-alerta">
                        {data.help?.heading && (
                            <h3 className="info-linea">
                                <img
                                    className="icono"
                                    src="/imgs/pregunta.svg"
                                    alt={data.ui?.icons?.helpAlt || data.ui?.iconAltDefault}
                                />
                                {data.help.heading}
                            </h3>
                        )}
                        {data.help?.textHtml && (
                            <p dangerouslySetInnerHTML={{ __html: data.help.textHtml }} />
                        )}
                        {data.help?.cta && (
                            <div className="ayuda-contacto-box">
                                <p>{data.help.cta}</p>
                            </div>
                        )}
                    </div>

                    {/* Información de contacto */}
                    <div className="contacto-info-extra">
                        {data.info?.title && <h4>{data.info.title}</h4>}

                        {phones.length > 0 && (
                            <div className="info-linea">
                                <img
                                    className="icono"
                                    src="/imgs/telefono.svg"
                                    alt={data.ui?.icons?.phoneAlt || data.ui?.iconAltDefault}
                                />
                                <div>
                                    <strong>{data.info.phoneLabel}</strong><br />
                                    {phones.join(' / ')}
                                </div>
                            </div>
                        )}

                        {emails.length > 0 && (
                            <div className="info-linea">
                                <img
                                    className="icono"
                                    src="/imgs/correo.svg"
                                    alt={data.ui?.icons?.emailAlt || data.ui?.iconAltDefault}
                                />
                                <div>
                                    <strong>{data.info.emailLabel}</strong><br />
                                    {emails.map((em, i) => (
                                        <span key={i}>
                                            <a href={`mailto:${em}`}>{em}</a>
                                            {i < emails.length - 1 ? <><br /></> : null}
                                        </span>
                                    ))}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
}
